import { alt } from 'common-frontend'

export default alt



// WEBPACK FOOTER //
// ./app/alt.js